// Static UI constants for the storefront.
// Products, testimonials, and per-SKU image dicts now live in MongoDB and are
// fetched at runtime — this file only carries truly static brand / UI copy.

export const BRAND = {
  name: "Certified Wellness",
  shortName: "Certified",
  mark: "CW",
  tagline: "Precision Peptide Research",
  subTagline: "Clinical-grade compounds. Clean. Consistent. Trusted.",
  email: "support@certifiedwellness.net",
  phone: "1-800-555-1234",
  coupon: "CW10",
  mantra: "Stronger. Cleaner. Balanced. Built to lead.",
};

// Hero banner + universal placeholder are self-hosted on the backend.
// Using REACT_APP_BACKEND_URL keeps the URLs portable across environments.
export const HERO_IMAGE = `${process.env.REACT_APP_BACKEND_URL}/api/static/images/c1sdcpud_CW_HERO_BAnner_COmpliant.png`;
export const PRODUCT_PLACEHOLDER = `${process.env.REACT_APP_BACKEND_URL}/api/static/images/98unnpyb_placeholder.png`;

export const CATEGORIES = [
  { slug: "peptides", name: "Peptides" },
  { slug: "blends", name: "Blends" },
  { slug: "supplies", name: "Supplies" },
];

export const FEATURES = [
  { title: "Lab Tested Purity", desc: "Every batch verified by independent third-party HPLC analysis." },
  { title: "Made in the USA", desc: "Synthesized and packaged in FDA-registered American facilities." },
  { title: "Discreet Shipping", desc: "Fast, tracked & temperature-controlled delivery, shipped worldwide." },
  { title: "COA on Every Vial", desc: "Certificate of Analysis included or downloadable for every product." },
];
